// extracted by mini-css-extract-plugin
module.exports = {"upload-image":"youtubeGif_upload-image__3_cQo","upload-heading":"youtubeGif_upload-heading__1pBfD","upload-go":"youtubeGif_upload-go__1H9Oe"};